<ng-container *ngComponentOutlet="LoaderComponent">
</ng-container>

<div class="row modal-content slider-content watermark-bg">
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeSlideShow()"
        style="top:-15px; z-index: 1;">
        <span aria-hidden="true" class="">&times;</span>
    </button>
    <div class="row ka-em-slide-counts"  *ngIf="slideShowData.length > 0">
        <div class="col-md-3">
            Total Records : {{currentSlider}} of {{slideShowCount}}
        </div>
        <div class="col-md-2">Viewed {{viewCount}} Profiles

        </div>
        <div class="col-md-1">
            <input matInput class="form-control" placeholder="Go to" (focusout)="onGoToFieldChange($event)"
            (keydown.enter)="onGoToFieldChange($event)" (keypress)="omit_specialChar_and_char($event)">
        </div>
        <div class="col-md-2">
            <span style="cursor: pointer;" (click)="activateSlideShow(isSlideShowActivated)"><img
                    *ngIf="isSlideShowActivated===false" src="../../../../assets/img/profile/slideshow_ic.svg"
                    alt=""></span>
            <span style="cursor: pointer;" (click)="activateSlideShow(isSlideShowActivated)"><img
                    *ngIf="isSlideShowActivated===true" src="../../../../assets/img/profile/slideshow_ic.svg"
                    alt=""></span>
        </div>
    </div>
    <div class="col-md-12" *ngIf="slideShowData.length > 0">
        <button type="button" class="arrow-common slide-profile-left">
            <img *ngIf="currentSlider >1" src="../../../../assets/img/home/leftarrow_ic.svg" alt=""></button>
        <button type="button" class="arrow-common slide-profile-right">
            <img *ngIf="currentSlider < slideShowCount" src="../../../../assets/img/home/rightarrow_ic.svg"
                alt=""></button>
        <ngx-slick-carousel #slickModal="slick-carousel" [config]="slideConfig"
            (afterChange)="afterChange($event)" (beforeChange)="beforeChange($event)">
            <div ngxSlickItem *ngFor="let profile of slideShowData" class="imgContainer">
                <div class="row" *ngIf="mode==='keywordSearch'">
                    <div class="col-md-6" style="padding: 30px;">
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">ProfileId</div> :
                            <div class="col">
                                <span style="cursor: pointer;">
                                    <i class="fa  fa-clipboard" (click)="copyProfileId(profile['profileID'])"
                                        aria-hidden="true"></i>
                                </span>
                                <span (click)="copyProfileId(profile['profileID'])" *ngIf="mode==='keywordSearch'"
                                    class="ka-em-profileId"(click)="navigateToViewProfileByProfileId(profile['profileID'])"
                                    [ngStyle]="{'color':getAssignTktColour(profile['paid'])}">{{getProfileTypeWithProfileID(profile)}}
                                    <span *ngIf="profile?.BrokerCode != null">({{profile?.BrokerCode}})</span>
                                </span>
                                <span *ngIf="profile?.KMPLID != null"> - {{profile?.KMPLID}}</span>
                            </div>
                            <div class="col-md-2">
                                <img (click)="naviagteToHoroscope(profile['horoScopeImage'])"
                                    *ngIf="profile['horoscopeStatus'] === 1"
                                    src="../../../../assets/img/dashboard/ico_horoscope.jpg"
                                    style=" width: 30% !important;height: 20px !important; padding: 0px !important;cursor: pointer;margin-left: -86%;">

                            </div>
                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">Name</div> :
                            <div class="col font-weight-bold">
                                {{profile['lastName']}} {{profile['firstName']}}
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">DOB(Age)</div> :
                            <div class="col font-weight-bold">
                                {{profile['dob']}}({{profile['age']}})
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">Height</div> :
                            <div class="col font-weight-bold">
                                {{profile['height']}}
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">TOB</div> :
                            <div class="col font-weight-bold">
                                {{profile['tob']}}
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">Place of birth</div> :
                            <div class="col font-weight-bold">
                                {{profile['placeOfBirth']}}
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">Gothram</div> :
                            <div class="col font-weight-bold">
                                {{profile['gothram']}}
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">Caste</div> :
                            <div class="col font-weight-bold">
                                {{profile['motherTongue']}} - {{profile['caste']}}
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">Star</div> :
                            <div class="col font-weight-bold">
                                {{profile['motherTongue']}} - {{profile['star']}}
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">Marital Status</div> :
                            <div class="col font-weight-bold">
                                {{profile['maritalstatus']}}
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">Qualification</div> :
                            <div class="col font-weight-bold">
                                {{profile['educationGroup']}}
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <!-- <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">Education Category</div> :
                            <div class="col font-weight-bold">
                                {{profile['educationspecialisation']}} 
                            </div>
                            <div class="col-md-2"></div>

                        </div> -->
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">University</div> :
                            <div class="col font-weight-bold">
                                {{profile['universityName']}} 
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">Profession</div> :
                            <div class="col font-weight-bold">
                                {{profile['profession']}}
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">Job Location</div> :
                            <div class="col font-weight-bold">
                                {{profile['jobLocation']}}
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">Income(P.M)</div> :
                            <div class="col font-weight-bold">
                                {{profile['income']}}
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">Father/Mother Native</div> :
                            <div class="col font-weight-bold">
                                {{profile['ffNative']}} / {{profile['mfNative']}}
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                        <div class="row mb-1">
                            <div class="col ka-em-slide-content-label">Property</div> :
                            <div class="col font-weight-bold">
                                {{profile['property']}} <span *ngIf="profile?.Property != null">({{profile['PropertyType']}})</span>
                            </div>
                            <div class="col-md-2"></div>

                        </div>
                      
                    </div>
                    <div class="col-md-6">
                        <div class="row ka-slideShow-image">
                            <img src="{{profile['customerApplicationPhoto']}}" class=" -img"
                                (click)="getUserPhotoGal(profile['customerApplicationPhoto'],profile['cust_ID'])"
                                style="cursor: pointer;">
                        </div>
                        <div class="row" style="justify-content: center;">
                            <span *ngIf="profile['photoCount']===0" class="ka-em-photo-count"
                                (click)="photoRequest(profile['profileID'])">Photo
                                Request</span>
                            <span *ngIf="profile['photoCount']>0">No Of Photos:
                                {{profile['photoCount']}}</span>

                        </div>
                        <div class="container" *ngIf="isSlideShowActivated">
                            <div class="row d-flex justify-content-center">                                
                                <div class="col p-1 ml-5 d-flex justify-content-end">                                    
                                    <span style="padding-left: 1%;">
                                        <i class="far fa-solid fa-envelope ka-slideshow-icon" style="cursor: pointer;" aria-hidden="true"
                                        matTooltip="{{profile?.primaryemail}}" (click)="showDetails(profile?.primaryemail)"></i>
                                    </span>
                                    <span *ngIf="profile['cEmailVerStatus']===null || profile['cEmailVerStatus']===false"
                                        class="ka-em-mobile-email">
                                         <span class="ka-em-profileId"
                                            (click)="verifyEmail(profile['cust_ID'])"><i class="far fa-times-circle ka-slideshow-icon" style="color: red;"></i></span>
                                    </span>
                                    <span *ngIf="profile['cEmailVerStatus']!=null &&  profile['cEmailVerStatus']===true"
                                        style="color: green;" class="ka-em-mobile-email"><i
                                            class="far fa-check-circle ka-slideshow-icon" matTooltip="Verified"></i></span>
                                </div>
                                <div class="col p-1 mr-5">                                    
                                    <span style="padding-left: 1%;">
                                        <i class="fas fa-mobile-alt ka-slideshow-icon" style="cursor: pointer;" aria-hidden="true"
                                        matTooltip="{{profile?.primarynumber}}" (click)="showDetails(profile?.primarynumber)"></i>
                                    </span>
                                    <span *ngIf="profile['cNumberVerStatus']===null || profile['cNumberVerStatus']===false"
                                        class="ka-em-mobile-email">
                                         <span class="ka-em-profileId"
                                            (click)="verifyMobileNumber(profile['cust_ID'],profile['primarynumber'])"><i class="far fa-times-circle ka-slideshow-icon" style="color: red;"></i></span>
                                    </span>
                                    <span *ngIf="profile['cNumberVerStatus']!=null &&  profile['cNumberVerStatus']===true"
                                        style="color: green;" class="ka-em-mobile-email" matTooltip="Verified"><i
                                            class="far fa-check-circle ka-slideshow-icon"></i></span>
                                            <span (click)="getOfficePurposeData(profile.cust_ID)"
                                            *ngIf="profile.Gender === 'Male'" style="font-size: 18px;cursor: pointer;padding-left: 10px;" [ngClass]="{'ka-em-officePurposeGroom': profile.isAboutProfile}">
                                              <i class="fas fa-comment"></i></span>
                                              <span (click)="getOfficePurposeData(profile.cust_ID)"
                                            *ngIf="profile.Gender === 'Female'" style="font-size: 18px;cursor: pointer;padding-left: 10px;" [ngClass]="{'ka-em-officePurposeBride': profile.isAboutProfile}">
                                              <i class="fas fa-comment"></i></span>
                                
                            </div>
                            </div>                        
                                
                            
                        </div>

                        <div class="top-section pl-3 pr-3 pt-1 pb-1" *ngIf="isSlideShowActivated">
                            <div class="row">
                                <div class="col-4 ka-em-slide-content-label">DOR</div> :
                                <div class="col font-weight-bold">
                                    {{profile['dor']}}
                                </div>
                                
                            </div>
                            <!-- <div class="row">
                                <div class="col ka-em-slide-content-label">Education Grade</div> :
                                <div class="col font-weight-bold">
                                    {{profile['EducationGrade']}}
                                </div>
                                
                            </div> -->
                            <!-- <div class="row">
                                <div class="col ka-em-slide-content-label">Payment Offer</div> :
                                <div class="col font-weight-bold">
                                    <span style="color: #06347e; cursor: pointer;" (click)="navigateToViewOffers(profile?.profileID)" *ngIf="profile?.offerStatus === 1;else viewOffer">View Offers</span>
                                    <ng-template #viewOffer>
                                        <span *ngIf="loginData['isAdmin'] === 1" style="color: red; cursor: pointer;" (click)="openPaymentOffer(profile)">Create Offer</span>
                                        <span *ngIf="loginData['isAdmin'] !== 1" style="color: red;">Create Offer</span>
                                    </ng-template>
                                </div>
                                
                            </div> -->
                            <div class="row">
                                <div class="col-4 ka-em-slide-content-label">Last Login</div> :
    
                                <div class="col font-weight-bold"
                                    *ngIf="profile['lastLoginDate']!=null && profile['lastLoginDate']!='' && profile['lastLoginDate']!=undefined">
                                    <span>{{profile['lastLoginDate']}}</span>
                                </div>
                                <div class="col ka-em-profileId"
                                    *ngIf="(profile['lastLoginDate']===null || profile['lastLoginDate']==='' || profile['lastLoginDate']===undefined)">
                                    <span (click)="forgotPassword(profile['profileID'])">
                                        Forgot Password
                                    </span>
                                </div>
                                
    
                            </div>
                            <!-- <div class="row">
                                <div class="col ka-em-slide-content-label">Mobile Last Login</div> :
    
                                <div class="col font-weight-bold"
                                    *ngIf="profile['LastMobileLoginDate']!=null && profile['LastMobileLoginDate']!='' && profile['LastMobileLoginDate']!=undefined">
                                    <span>{{profile['LastMobileLoginDate']}}</span>
                                </div>
                                <div class="col ka-em-profileId"
                                    *ngIf="(profile['LastMobileLoginDate']===null || profile['LastMobileLoginDate']==='' || profile['LastMobileLoginDate']===undefined)">
                                    <span (click)="forgotPassword(profile['profileID'])">
                                        Forgot Password
                                    </span>
                                </div>
                                
    
                            </div> -->
                            <div class="row">
                                <div class="col-4 ka-em-slide-content-label">Send/Recv</div> :
                                <div class="col font-weight-bold">
                                    <span *ngIf="profile['srCount']!=null" class="ka-em-profileId"
                                        (click)="navigateToCommunicationLog(profile['profileID'])">
                                        {{profile['srCount']}}
                                    </span>
                                    <span style="color: red;" *ngIf="profile['srCount']===null">No Service</span>
    
                                </div>
                                
    
                            </div>
                            <div class="row">
                                <div class="col-4 ka-em-slide-content-label">Payment</div> :
                                <div class="col font-weight-bold">
                                    <span *ngIf="profile['paidAmount']!=null && profile['paidAmount']!=''"
                                        class="ka-em-profileId" (click)="navigateToPaymentPage(profile['profileID'])">{{profile['paidAmount']}} ({{profile['paymentDate']}})</span>
                                    <span style="color: red;" *ngIf="profile['paidAmount']===null || profile['paidAmount']===''">Not
                                        Paid</span>
                                </div>
                                
    
    
                            </div>
                            <div class="row" [hidden]="profile['expiryDate'] == null || profile['expiryDate'] == ''">
                                <div class="col-4 ka-em-slide-content-label">Expired Date</div> :
                                <div class="col font-weight-bold">
                                    <span style="color: red; cursor: pointer;" (click)="navigateToPaymentPage(profile['profileID'])">{{profile['expiryDate']}} ({{profile['points']}})</span>
                                </div>
                                
    
                            </div>
                            <div class="row">
                                <div class="col-4 ka-em-slide-content-label">Marketing Ticket</div> :
                                <div class="col font-weight-bold">
                                    <span class="ka-em-profileId"
                                        (click)="viewMarketingTicket(profile['Emp_Ticket_ID'])">{{profile['ticketID']}}
                                    </span>
                                    <span> ({{profile['profileOwnername']}} - {{profile['empUserName']}})</span> ({{profile?.NoofDays === 1 ? (profile?.NoofDays + ' day') : (profile?.NoofDays + ' days')}})
    
                                </div>
                                
    
                            </div>
                            <div class="row">
                                <div class="col-4 ka-em-slide-content-label">Match Meetings</div> :
                                <div class="col font-weight-bold">
                                    <span class="ka-em-profileId"
                                        (click)="navigateToCommunicationLog(profile['profileID'])">
                                        {{profile['matchMeetingCount']}}
                                    </span>
                                </div>
                                
    
                            </div>
                            <!-- <div class="row">
                                <div class="col-4 ka-em-slide-content-label">SA Form</div> :
                                <div class="col font-weight-bold">
                                    <span style="color: #06347e;" *ngIf="profile['saForm']!=null" (click)="viewSAForm(profile['saForm'])"
                                        class="ka-em-profileId">View SA
                                        Form</span>
                                    <span style="color: red;" *ngIf="profile['saForm']===null"
                                        (click)="uploadSAForm(profile['profileID'])" class="ka-em-SAForm">Upload SA
                                        Form</span>
    
                                </div>
                                
    
                            </div> -->
                            <div class="row">
                                <div class="col-4 ka-em-slide-content-label">Last Service Date</div> :
                                <div class="col font-weight-bold">
                                    <span>{{profile['lastService_Date']}}</span>
                                </div>
                                
    
                            </div>
                            <!-- <div class="row">
                                <div class="col-4 ka-em-slide-content-label">Website/Mobile Login Count</div> :
                                <div class="col font-weight-bold">
                                    <span>{{profile['websiteLoginCount']}} / {{profile['mobileLoginCount']}}</span>
                                </div>
                                
    
                            </div> -->
                        </div>
                    </div>
                </div>

                <div class="row ka-em-footer" *ngIf="mode==='myProfile'">

                    <!-- <div class="col-md-12 ka-em-footer-content">
                        <p class="footer-link" style="color: #06347e;" (click)="navigateToPartnerPrefarence(profile['cust_ID'])">Edit
                            Partner Preferences</p><span class="footer-divider">|</span>
                        <p class="footer-link" style="color: #06347e;" (click)="navigateToRegistrationValidation()">Search By Contact
                            </p><span class="footer-divider">|</span>
                        <p class="footer-link"style="color: #06347e;" (click)="navigateToContact(profile['cust_ID'])">View Contacts</p>
                            <span class="footer-divider">|</span><br>
                        <p class="footer-link" style="color: #06347e;"
                            (click)="navigateToSearch(profile['profileID'],'general')">General Search
                        </p>
                        <span class="footer-divider">|</span> 
                        <p class="footer-link" style="color: #06347e;"
                        (click)="navigateToSearch(profile['profileID'],'advanced')">Advanced Search
                        </p>
                        <span class="footer-divider">|</span>   
                        <p class="footer-link" style="color: #06347e;">Delete Profile</p><span class="footer-divider">|</span>
                        <p (click)="navigateToMyProfile(profile['profileID'])" class="footer-link" style="color: #06347e;">My Profile</p>

                    </div>
                    <div class="col-md-12 ka-em-footer-content" style="justify-content: center;">
                        <p class="footer-link" (click)="openMarketingSlideShow()">Marketing Slide Show</p><span
                            class="footer-divider">|</span>
                        <p class="footer-link" (click)="openMatchFowllowupSlideShow()">Followup Slide Show</p>
                        <span class="footer-divider">|</span>
                        <p class="footer-link">Create Remainder</p>
                    </div> -->


                </div>

            </div>
        </ngx-slick-carousel>
        <!-- <div class="col-md-12 text-center">
                    <span style="cursor: pointer;" (click)="activateSlideShow(isSlideShowActivated)"><img
                            *ngIf="isSlideShowActivated===false" src="../../../../assets/img/profile/slideshow_ic.svg"
                            alt="" style="height: 28px !important;"></span>
                    <span style="cursor: pointer;" (click)="activateSlideShow(isSlideShowActivated)"><img
                            *ngIf="isSlideShowActivated===true"
                            src="../../../../assets/img/profile/slideshowpauce_ic.svg" alt=""
                            style="height: 28px !important;"></span>
                </div> -->


    </div>

    <div class="no-records" *ngIf="slideShowData.length === 0">
        No Records Found
    </div>

</div>

<div mdbModal #successModal="mdbModal" class="modal fade" tabindex="-1" role="dialog"
aria-labelledby="myBasicModalLabel" aria-hidden="true"
[config]="{backdrop: true, ignoreBackdropClick: true,  keyboard: false}">
    <div class="modal-dialog modal-md modal-dialog-centered" role="document">

        <div class="modal-content">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                (click)="successModal.hide()">
                <span aria-hidden="true" class="">&times;</span>
            </button>
            <div class="row text-left">

                <!--Grid column-->
                <div class="col-md-12 rmSectionPopup">
                    <div class="row p-2 m-2">

                        <div class="col-md-12 rmDetailsSectionPopup" style="text-align: center;">
                            <!-- <img src="../../../../assets/img/dashboard/rm_temp.PNG" /> -->
                            <p class="mt-2 p-0">{{responseMessage}} </p>

                            <div class="action-buttons">
                                <button mdbBtn
                                    class="ka-white-button  tButton ka-btn-primary btn-success btn mb-3 mt-2"
                                    mdbWavesEffect type="submit" (click)="successModal.hide()">ok
                                </button>



                            </div>

                        </div>
                    </div>

                </div>

                <!--Grid column-->



            </div>
        </div>
    </div>
</div>

<div mdbModal #basicModal="mdbModal" class="modal fade" tabindex="-1" role="dialog"
aria-labelledby="myBasicModalLabel" aria-hidden="true"
[config]="{backdrop: true, ignoreBackdropClick: true,  keyboard: false}">
<div class="modal-dialog modal-md" role="document">

 
</div>

</div>